import { jsxs as O, jsx as t } from "react/jsx-runtime";
import { c as q } from "./index-65016bfa.mjs";
import { useRef as E } from "react";
import N from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as F } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as Q } from "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
const T = N.button`
  &.Button {
    ${({ theme: { components: { button: { Component: i } = {} } = {} }, $isAnchorUnderlined: s, $size: r = "medium" }) => `
      display: ${i == null ? void 0 : i.display};
      flex-direction: ${i == null ? void 0 : i.flexDirection};
      justify-content: ${i == null ? void 0 : i.justifyContent};
      width: ${i == null ? void 0 : i.width};
      height: ${i == null ? void 0 : i.height};
      align-items: ${i == null ? void 0 : i.alignItems};
      box-sizing: ${i == null ? void 0 : i.boxSizing};
      position: ${i == null ? void 0 : i.position};
      border-radius: ${i == null ? void 0 : i.borderRadius};
      letter-spacing: ${i == null ? void 0 : i.letterSpacing};
      white-space: ${i == null ? void 0 : i.whiteSpace};
      cursor: ${i == null ? void 0 : i.cursor};
      text-decoration: ${s ? "underline" : "none"};
      padding: ${i == null ? void 0 : i.padding[r]};
      font-family: ${i == null ? void 0 : i.textStyle[r].fontFamily};
      font-size: ${i == null ? void 0 : i.textStyle[r].fontSize};
      font-weight: ${i == null ? void 0 : i.textStyle[r].fontWeight};
      line-height: ${i == null ? void 0 : i.textStyle[r].lineHeight};
      vertical-align: ${i == null ? void 0 : i.verticalAlign};
      flex-shrink: ${i == null ? void 0 : i.flexShrink};

      --icon-margin: ${i == null ? void 0 : i.iconMargin};
      --svg-wrapper-width: ${i == null ? void 0 : i.svgWrapperWidth[r]};
      --svg-wrapper-height: ${i == null ? void 0 : i.svgWrapperHeight[r]};

      &:focus-visible {
        outline: ${i == null ? void 0 : i.focus.outline};
        outline-offset: ${i == null ? void 0 : i.focus.outlineOffset};
      }

      &--disabled {
        pointer-events: none;
        outline: none;
      }

      &--full-width {
        width: 100%;
      }

       &--text{
        padding: ${i == null ? void 0 : i.textPadding[r]};
      }
    `}

    ${({ theme: { components: { button: { Component: i } = {} } = {} }, $variant: s = "solid", $color: r = "primary" }) => {
  var a, f, u, d, g, $, h, c, b, l, y, w, x, v, B;
  return `
        color: ${(f = (a = i == null ? void 0 : i.color[r]) == null ? void 0 : a[s]) == null ? void 0 : f.color};
        background-color:${(g = (d = (u = i == null ? void 0 : i.color) == null ? void 0 : u[r]) == null ? void 0 : d[s]) == null ? void 0 : g.backgroundColor};
        border:${(h = ($ = i == null ? void 0 : i.color[r]) == null ? void 0 : $[s]) == null ? void 0 : h.border};
        &:hover {
          background-color: ${(l = (b = (c = i == null ? void 0 : i.color) == null ? void 0 : c[r]) == null ? void 0 : b[s]) == null ? void 0 : l.hover.backgroundColor};
          color:${(x = (w = (y = i == null ? void 0 : i.color) == null ? void 0 : y[r]) == null ? void 0 : w[s]) == null ? void 0 : x.hover.color};
          border:${(B = (v = i == null ? void 0 : i.color[r]) == null ? void 0 : v[s]) == null ? void 0 : B.hover.border};
        }
      `;
}};
  }
`, S = N.div`
  &.Button__icon-wrapper {
    ${({ theme: { components: { button: { Component: i } = {} } = {} }, $rightIcon: s, $leftIcon: r, $size: a = "medium" }) => `
      ${s ? "margin-left: var(--icon-margin);" : ""};
      ${r ? "margin-right: var(--icon-margin);" : ""};
      width: ${i == null ? void 0 : i.svgWrapperWidth[a]};
      height: ${i == null ? void 0 : i.svgWrapperHeight[a]};
      display: flex;

      svg, img {
        width: ${i == null ? void 0 : i.svgWrapperWidth[a]};
        height: ${i == null ? void 0 : i.svgWrapperHeight[a]};
      }
    `}
  }
`, U = (i) => (i == null ? void 0 : i.charAt(0)) !== "/", n = ({
  size: i = "medium",
  isDisabled: s = !1,
  onClick: r,
  children: a,
  className: f,
  leftIcon: u,
  rightIcon: d,
  variant: g = "solid",
  color: $ = "primary",
  isAnchorUnderlined: h = !1,
  href: c,
  as: b = "button",
  renderAs: l = b,
  target: y,
  accessibilityOptions: w = {},
  id: x,
  dataTestId: v,
  fullWidth: B,
  ...P
}) => {
  const L = F({ label: "Button" }), _ = E(), j = Q("button", { ...w, ariaDisabled: s }, _), W = y ?? (U(c) ? "_blank" : "_self"), H = l === "a", A = l !== "a" && l !== "button";
  function R(k) {
    if (s)
      return k.preventDefault();
    r == null || r(k);
  }
  const I = {
    target: W,
    href: c,
    $isAnchorUnderlined: h
  }, M = { target: W, href: c, to: c };
  return /* @__PURE__ */ O(
    T,
    {
      ref: _,
      onClick: R,
      $size: i,
      $variant: g,
      $color: s ? "disabled" : $,
      $isAnchorUnderlined: h,
      className: q(
        "Button",
        `Button--${g}`,
        {
          "Button--disabled": s,
          "Button--full-width": B
        },
        f
      ),
      disabled: s,
      "data-testid": v,
      id: x,
      as: l,
      ...L,
      ...j,
      ...P,
      ...H && I,
      ...A && M,
      children: [
        u && a && /* @__PURE__ */ t(
          S,
          {
            className: "Button__icon-wrapper Button__icon-wrapper-left",
            $leftIcon: !0,
            $size: i,
            children: u
          }
        ),
        a,
        d && a && /* @__PURE__ */ t(
          S,
          {
            className: "Button__icon-wrapper Button__icon-wrapper-right",
            $rightIcon: !0,
            $size: i,
            children: d
          }
        )
      ]
    }
  );
};
export {
  n as Button
};
